/* Copyright (c) 2020-present CloudIO Inc */

import IOError from './IOError';

export const ABORT_ERROR = 'AbortError';

export default class AbortError extends IOError {
  name: string;

  constructor() {
    super(ABORT_ERROR, ABORT_ERROR);
    this.name = ABORT_ERROR;
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, AbortError);
    }
  }
}
